import React from "react";
import PropTypes from "prop-types";

import styles from "./RadioButtonSet.module.scss";
import clsx from "clsx";
import Label from "../Label/Label";
import RadioButton from "../RadioButton/RadioButton";
import ErrorMessage from "../Form/ErrorMessage";
import useWindowSize from "../utils/useWindowSize";

const RadioButtonSet = ({
  choices,
  disabled,
  defaultValue,
  onChange,
  errors,
  label,
  colorLabelSet,
  colorLabel,
  labelClass,
  name,
  errorMessages,
  className,
  color,
}) => {
  const { width } = useWindowSize();

  const radioButtonSetClasses = clsx(styles.radioButtonSet, className);

  return (
    <div className={radioButtonSetClasses} data-testid="RadioButtonSet">
      {label && (
        <Label color={colorLabelSet} className={labelClass} htmlFor={name}>
          {label}
        </Label>
      )}
      {choices.map((item, i) => (
        <div key={i}>
          <RadioButton
            alignment={width > 576 ? "left" : "right"}
            name={name}
            disabled={disabled}
            onChange={onChange}
            value={defaultValue}
            item={item}
            color={color}
            colorLabel={colorLabel}
          />
        </div>
      ))}
      <ErrorMessage errorMessages={errorMessages} errors={errors} label={label} name={name} />
    </div>
  );
};

RadioButtonSet.propTypes = {
  color: PropTypes.oneOf(["primary", "error"]),
  choices: PropTypes.array,
  disabled: PropTypes.bool,
  errors: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
  errorMessages: PropTypes.object,
  label: PropTypes.string,
  colorLabel: PropTypes.string,
  colorLabelSet: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  labelClass: PropTypes.string,
};

RadioButtonSet.defaultProps = {
  color: "primary",
  choices: [],
  disabled: false,
  errors: {},
  errorMessages: {},
  label: "",
  name: "",
  className: "",
};

export default RadioButtonSet;
